import React from "react";
import { SummaryModal, SummaryTable, SummaryTableHeader, SummaryTableRow, SummaryTablePriceRow, SummaryModalRingScreenshot, SummaryTablePrintRow, SummaryTableReferenceNumberRow, SummaryModalLogoContainer, SummaryTableTitle } from "./SummaryModal-styled";
import { IMetalGroup, IStoneGroup } from "../../../../sharedInterfaces";
import { CARAT_CONVERSION_CHARTS } from "../../../../Model/CaratSizes";
import { engraving } from "../../ui-helpers/svg-icon/icons";
import { getFontCssClass } from "../../Tabs/Engraving/helpers";
import { PrinterOutlined } from "@ant-design/icons";


interface Props {
  summaryModalVisible:boolean,
  setSummaryModalVisibility:(value)=>void,
  isMobile:boolean,
  isLowHeight:boolean,
  assetURI:string,

  ringSKU:string,
  ringScreenshot:string,
  configID:string,
  fingerSize:string,
  ringWidth:number,
  ringThickness:number,
  price:number,
  metalGroups:IMetalGroup[],
  stoneCut:'Brilliant'|'Princess'|'Baguette',
  stoneCount:number,
  stoneSize:number,
  stoneGroups:IStoneGroup[],
  engravingText:string,
  engravingFont:'Brush Script'|'Century Gothic'|'Snell Roundhand'|'Trajan'|'Dakota',
  limitedMaterials:string[]
}

export default class extends React.Component<Props,{}> {
  constructor(props: Props) {
    super(props);
  };// /constructor()

  private _getMetalGroupInfoString = (mg:IMetalGroup):string => {
    let infoString = '';

    if (mg.material && mg.materialOptions.length > 0) {
      infoString += mg.material;
      if (mg.purity) infoString += ` (${mg.purity})`;
      if (mg.surface && !this.props.limitedMaterials.includes(mg.material)) infoString += `, ${mg.surface}`;
    } else {
      if (mg.surface) infoString += mg.surface;
    };

    return infoString;
  };

  private _getStoneGroupInfoString = (sg:IStoneGroup):string => {
    const { stoneCut, stoneSize } = this.props;
    let infoString = '';

    const getStoneSizeString = ():string => {
      const caratConversionChart = CARAT_CONVERSION_CHARTS.find((ccc) => (ccc.stoneType.includes(sg.stone) && ccc.stoneCut.includes(stoneCut) ));
      if (caratConversionChart) {
        const caractConversion = caratConversionChart.chart.find((cc) => cc.mm === stoneSize);
        if (caractConversion) {
          return `, ${caractConversion.ct}ct (~${stoneSize}mm)`;
        }
      }

      return `, ${stoneSize}mm`;
    };

    if (sg.stone) {
      infoString += sg.stone;
      infoString += getStoneSizeString();
    };

    return infoString;
  };

  render = () => {
    const {
      summaryModalVisible,
      setSummaryModalVisibility,
      isMobile,
      isLowHeight,
      assetURI,
      ringSKU,
      ringScreenshot,
      fingerSize,
      ringWidth,
      ringThickness,
      price,
      metalGroups,
      stoneCut,
      stoneCount,
      stoneGroups,
      engravingText,
      engravingFont,
      configID
    } = this.props;

    return(
      <SummaryModal className="threed-configurator-checkout-modal"
        mobile={isMobile}
        lowHeight={isLowHeight}
        visible={summaryModalVisible}
        footer={null}
        onCancel={() => { setSummaryModalVisibility(false) }}
        maskClosable={true}
      >
        <SummaryModalLogoContainer>
          <img src={`${assetURI}/images/logo/Logo_IFR_Text.png`} draggable={false}/>
        </SummaryModalLogoContainer>

        { ringScreenshot &&
          <SummaryModalRingScreenshot src={ringScreenshot}></SummaryModalRingScreenshot>
        }

        <SummaryTable>
          <tbody>
            <SummaryTableTitle>
              <td colSpan={2}>{`Your ring - ${ringSKU}`}</td>
            </SummaryTableTitle>

            <SummaryTableHeader>
              <td colSpan={2}>Dimensions</td>
            </SummaryTableHeader>
            <SummaryTableRow>
              <td>Size</td>
              { fingerSize !== '--' && <td>{fingerSize}</td> }
              { fingerSize === '--' && <td style={{fontWeight:'bold'}}>(Please select!)</td> }
            </SummaryTableRow>
            <SummaryTableRow>
              <td>Width</td>
              <td>{ringWidth}</td>
            </SummaryTableRow>
            <SummaryTableRow>
              <td>Thickness</td>
              <td>{ringThickness}</td>
            </SummaryTableRow>

            { metalGroups.length > 0 && 
              <SummaryTableHeader>
                <td colSpan={2}>Materials</td>
              </SummaryTableHeader>
            }
            { metalGroups.map((mg) => {
                return (
                  <SummaryTableRow key={mg.name}>
                    <td>{mg.name}</td>
                    <td>{this._getMetalGroupInfoString(mg)}</td>
                  </SummaryTableRow>
                )
              })
            }

            { stoneGroups.length > 0 && 
              <React.Fragment>
                <SummaryTableHeader>
                  <td colSpan={2}>Stones</td>
                </SummaryTableHeader>
                <SummaryTableRow>
                  <td>Count/ Cut</td>
                  <td>{stoneCount}/ {stoneCut}</td>
                </SummaryTableRow>
                { stoneGroups.map((sg) => {
                    return (
                      <SummaryTableRow key={sg.name}>
                        <td>{stoneGroups.length === 1 ? 'Type' : sg.name}</td>
                        <td>{this._getStoneGroupInfoString(sg)}</td>
                      </SummaryTableRow>
                    )
                  })
                }
              </React.Fragment>
            }

            { engravingText !== null && engravingText.length > 0 && // explicit !== null rather than just if (engravingText) is needed here to avoid react-dom.development.js:506 Warning: validateDOMNesting(...): Whitespace text nodes cannot appear as a child of <tbody>. Make sure you don't have any extra whitespace between tags on each line of your source code.
              <React.Fragment>
                <SummaryTableHeader>
                  <td colSpan={2}>Engraving</td>
                </SummaryTableHeader>
                <SummaryTableRow>
                  <td>Text</td>
                  <td className={getFontCssClass(engravingFont)}>{engravingText}</td>
                </SummaryTableRow>
                <SummaryTableRow>
                  <td>Font</td>
                  <td>{engravingFont}</td>
                </SummaryTableRow>
              </React.Fragment>
            }
            { (!engravingText || engravingText.length < 1) &&
              <React.Fragment>
                <SummaryTableHeader>
                  <td colSpan={2}>Engraving</td>
                </SummaryTableHeader>
                <SummaryTableRow>
                  <td colSpan={2}>None</td>
                </SummaryTableRow>
              </React.Fragment>
            }

            { price &&
              <SummaryTablePriceRow>
                <td>Total Price</td>
                <td>{`$ ${price.toLocaleString('en-US')}`}</td>
              </SummaryTablePriceRow>
            }

            { configID && 
              <SummaryTableReferenceNumberRow>
                <td>Reference ID:</td>
                <td>{configID}</td>
              </SummaryTableReferenceNumberRow>
            }

            <SummaryTablePrintRow>
              <td colSpan={2}>
                <span onClick={()=>window.print()}>
                  Print
                  <PrinterOutlined 
                    type="printer"
                  />
                </span>
              </td>
            </SummaryTablePrintRow>

          </tbody>
        </SummaryTable>

      </SummaryModal>
    )
  };// /render()

};// /class